export default __webpack_public_path__ + "static/media/class-outlined.dddd2c17.svg";